export default __webpack_public_path__ + "static/media/post1.96d56d09.png";